import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=c508564a&scoped=true"
import script from "./Sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sidebar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=c508564a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c508564a",
  null
  
)

export default component.exports